/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { AfterViewInit, Component, Inject, Injector, Type, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicHostDirective } from './dynamic-host.directive';

@Component({
	standalone: true,
	selector: 'app-aside-modal',
	templateUrl: './aside-modal-container.component.html',
	styleUrls: ['./aside-modal-container.component.scss'],
	imports: [DynamicHostDirective],
})
export class AsideModalContainerComponent implements AfterViewInit {
	@ViewChild(DynamicHostDirective, { static: true })
	host!: DynamicHostDirective;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: { component: Type<any>; inputs?: Record<string, any> },
		public dialogRef: MatDialogRef<AsideModalContainerComponent>,
		private injector: Injector,
	) {}

	ngAfterViewInit() {
		if (!this.data?.component) {
			return;
		}
		const childInjector = Injector.create({
			providers: [{ provide: MatDialogRef, useValue: this.dialogRef }],
			parent: this.injector,
		});
		const ref = this.host.vcr.createComponent(this.data.component);

		if (this.data.inputs) {
			Object.assign(ref.instance, this.data.inputs);
		}
	}
}
